<template>
  <div class="main">
    <c-panel>
      <form-gasto :paramId="$route.params.id" v-on:onSubmitGasto="onSubmitGasto"></form-gasto>
    </c-panel>
  </div>
</template>
<script>
import formGasto from "./form"

export default {
  methods: {
    onSubmitGasto () {
      this.$router.push('/admin/financeiro/gasto')
    }
  },
  components: { formGasto }
}
</script>

